import React, { Box, Stack, Typography } from '@mui/material';
import LoanStatusPill from 'Feature/V2/HbtMasterPool/shared/LoanStatusPill';
import { memo } from 'react';
import { getLoanStatusLabel } from '../../../HbtMasterPoolDetails/utils/masterPoolDetailsUtils';
import { loanStatusMapping } from '../../../HbtMasterPoolTable/utils/LoanStatusMapping';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { LoanInventoryTableFields } from '../../types';

interface HistoricalDataProps {
  header?: string;
  dateStamp?: string;
  timeStamp?: string;
  status?: string;
  editor?: string;
  remark?: string;
}

const HistoricalData = ({
  header,
  dateStamp,
  timeStamp,
  status,
  editor,
  remark
}: HistoricalDataProps) => {
  const { t } = useTranslation('HbtMasterPool');
  return (
    <Stack direction="column" className={styles.HistoricalDataComponent}>
      <Stack direction="row" className={styles.dateTimeHeader} justifyContent="space-between">
        <Typography className={styles.header}>{header}</Typography>
        <Stack direction="row" gap={1}>
          <Typography className={styles.dateTime}>{dateStamp}</Typography>
          <Typography className={styles.dateTime}>{timeStamp}</Typography>
        </Stack>
      </Stack>
      {status && (
        <Box className={styles.Status}>
          <LoanStatusPill
            status={status ?? ''}
            label={getLoanStatusLabel(status as keyof typeof loanStatusMapping, t)}
          />
        </Box>
      )}
      {remark && (
        <Typography variant="h6" className={styles.Remark}>
          {remark}
        </Typography>
      )}
      {editor && (
        <Typography variant="h6" className={styles.Editor}>
          {editor}
        </Typography>
      )}
    </Stack>
  );
};

export default memo(HistoricalData);
